module.exports = __webpack_public_path__ + "static/media/screen_face.e3843bc3.svg";